module.exports = __webpack_public_path__ + "img/banner.0b35e994.png";